import React from "react";
import { GoogleOutlined, FacebookFilled } from "@ant-design/icons";
import "../App.css";
import messVideo from "../assets/mess1.mp4";
import logo from "../assets/logo3.png";
import firebase from "firebase/compat/app";
import 'firebase/compat/auth'
import{auth } from '../firebase'



const Login = () => {
  return (
    <div className="flex justify-start items-center flex-col h-screen w-screen">
      <div className="relative w-full h-full">
        <video
          src={messVideo}
          type="video/mp4"
          loop
          controls={false}
          muted
          autoPlay
          className="w-full h-full object-cover"
        />

        <div className="absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0 bg-black bg-opacity-50">
          <div className="absolute flex flex-col justify-center items-center bg-sky-600 rounded-lg p-4">
            <h2 className="text-white font-bold text-2xl mb-4">
              Welcome to Unichat
            </h2>
            <img src={logo} width="130px" alt="logo" className="p-1 mb-4" />
            <div className="">
            <div className="shadow-2xl google rounded-lg p-8 mb-8 py-4 px-4 text-white font-semibold cursor-pointer" onClick={()=>auth.signInWithRedirect(new firebase.auth.GoogleAuthProvider())}>
              <GoogleOutlined /> Ingresa con
              Google
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
